<a href="/" [class]="customHrefClass" (window:resize)="onResize()">
    <img
        alt="Logo"
        *ngIf="!appSession.tenant || !appSession.tenant.HasLogo()"
        [src]="defaultLogo | unsafe: securityContext.URL"
        class="h-25px app-sidebar-logo-default"
    />
    <img
        alt="Logo"
        *ngIf="!appSession.tenant || !appSession.tenant.HasLogo()"
        [src]="defaultSmallLogo | unsafe: securityContext.URL"
        class="h-20px app-sidebar-logo-minimize"
    />
    <img
        alt="Logo"
        *ngIf="appSession.tenant && appSession.tenant.lightLogoId"
        [src]="
            (remoteServiceBaseUrl +
            '/TenantCustomization/GetTenantLogo?skin=' +
            currentTheme.baseSettings.menu.asideSkin +
            '&tenantId=' +
            appSession.tenant.id +
            '&id=' +
            appSession.tenant.lightLogoId)
            | unsafe: securityContext.URL
        "
        class="h-25px app-sidebar-logo-default"
    />
    <img
        alt="Logo"
        *ngIf="appSession.tenant && appSession.tenant.HasLogo()"
        [src]="
            remoteServiceBaseUrl +
            '/TenantCustomization/GetTenantLogo?skin=' +
            currentTheme.baseSettings.menu.asideSkin +
            '&tenantId=' +
            appSession.tenant.id
        "
        class="h-20px app-sidebar-logo-minimize"
    />
</a>
